import { addProp } from "@pnp/odata";
import { _Item } from "../items/types.js";
import { Attachments } from "./types.js";
addProp(_Item, "attachmentFiles", Attachments);
//# sourceMappingURL=item.js.map